// Profile of Nikolai Genov, French. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • Santé, sciences de la vie, finance',
  summary: 'Docteur en bio-informatique et responsable technique, associant développement logiciel assisté par l’IA et analyse de données dans les environnements réglementés de la santé, des sciences de la vie et de la finance. Expertise des systèmes LLM/RAG, de l’intégration MCP, des données cliniques, des prévisions bancaires jusqu’à cinq ans et du reporting Excel automatisé. Allie développement R/Python, coordination d’équipe, assurance qualité et ateliers pour dirigeants ; certification AI Act et formation GCP.',
  imageAlt: 'Portrait de Nikolai Genov',
  personal: {
    position: 'Cofondateur et gérant de pAIoneer Labs GmbH, gérant de Leap Dynamics GmbH',
    location: 'Berlin, Allemagne',
    languages: 'Allemand et anglais (courant), bulgare (courant)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'Certification AI Act, formation GCP (2025)',
    publications: 'Publications évaluées par des pairs dans Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology et PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Doctorat : bio-informatique / biologie théorique',
      institution: '',
      degree: 'Diplôme : doctorat (Dr. rer. nat.)'
    },
    {
      period: '2015',
      field: 'Études : bio-informatique',
      institution: 'Freie Universität Berlin',
      degree: 'Diplôme : M.Sc. en bio-informatique'
    },
    {
      period: '2012',
      field: 'Études : bio-informatique',
      institution: 'Freie Universität Berlin',
      degree: 'Diplôme : B.Sc. en bio-informatique'
    }
  ],
  skills: [
    {
      title: 'Compétences clés',
      description: 'Développement assisté par l’IA, R/Python, LLM/RAG et MCP, données cliniques et bio-informatique, prévisions et tests de résistance, reporting Excel, Shiny, direction technique'
    },
    {
      title: 'Programmation et analyse de données',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB ; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Applications et reporting',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX ; reporting Excel/Word/PDF automatisé'
    },
    {
      title: 'IA et intégration',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP) ; Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise ; développement assisté par l’IA avec revue humaine'
    },
    {
      title: 'Ingénierie',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Bio-informatique',
      description: 'RNA-seq, puces à ADN, épissage alternatif/isoformes, enrichissement d’ensembles de gènes, analyse de voies et de réseaux, assemblage de génomes, analyse de survie ; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Données cliniques',
      description: 'EDC, CRF, edit checks, DMP, plans de validation des données, UAT, réconciliation des SAE ; CDISC SDTM/ADaM, pipelines RAW/SDTM/ADaM, QC'
    }
  ],
  positions: [
    {
      period: '2022 - avril 2024',
      title: 'Automatisation du reporting, T-Systems / Banque centrale européenne (BCE)',
      description: [
        'Développement d’une bibliothèque R pour le reporting statistique de séries temporelles financières ; migration de la logique FAME vers R/Python avec Reticulate et sorties Word/PDF automatisées.',
        'Pipelines de génération automatisée de rapports Excel ; intégration des analyses avec Camunda et contribution à GitLab CI/CD, aux tests unitaires, au linting, à SonarQube et à la documentation technique.',
        'Suppléance du chef d’équipe et participation à la planification des sprints, à la coordination technique, à l’assurance qualité et aux échanges avec les parties prenantes.'
      ]
    },
    {
      period: 'Juin 2025 - décembre 2025',
      title: 'Data Science & Risk Analytics Consultant, secteur bancaire',
      description: [
        'Développement de modèles de prévision avec des horizons de planification allant jusqu’à cinq ans et mise en œuvre de tests de résistance.',
        'Réécriture et refactorisation de code R existant et optimisation de quatre processus métier ; développement assisté par l’IA avec revue humaine pour l’implémentation et la documentation.',
        'Flux de travail d’analyse R/Shiny et pipelines de génération automatisée de rapports Excel ; traduction des exigences métier en implémentations analytiques.'
      ]
    },
    {
      period: 'Juin 2025 - juin 2026',
      title: 'Clinical Data Manager, secteur pharmaceutique / études cliniques',
      description: [
        'Mise en place de l’EDC, conception des CRF, edit checks, rôles utilisateurs, spécifications de transfert de données et UAT ; coordination avec les CRO, les laboratoires et les équipes d’étude.',
        'Rédaction et revue de DMP, de plans de validation, de plans de réconciliation des SAE et de la documentation UAT ; développement de flux de travail de validation en R et d’applications Shiny dans un contexte soumis aux GCP.'
      ]
    },
    {
      period: 'Juillet 2026',
      title: 'Pipeline de données cliniques, Dr. Falk Pharma',
      description: [
        'Pipeline d’analyse RAW/SDTM/ADaM en R avec OpenCode et développement assisté par l’IA, avec validation, QC, traçabilité et pipelines automatisés de rapports Excel.'
      ]
    },
    {
      period: '2026',
      title: 'Reporting de piste d’audit assisté par l’IA, Miltenyi Biotec',
      description: [
        'Mise en œuvre de rapports de piste d’audit et de pipelines automatisés de rapports Excel avec OpenCode et développement assisté par l’IA, y compris logique de reporting, débogage, documentation et revue humaine.'
      ]
    },
    {
      period: 'Depuis 2019',
      title: 'Gérant et cofondateur / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Direction du conseil et de la réalisation technique dans la santé, les sciences de la vie, la finance et l’IA, en combinant développement en propre, coordination d’équipe et communication avec les parties prenantes.',
        'Conception d’une infrastructure LLM/RAG et d’une intégration d’outils fondée sur MCP ; mise en place de flux de travail R/Python assistés par OpenCode pour la génération de code, la refactorisation, les tests et la documentation avec revue humaine.'
      ]
    },
    {
      period: 'Depuis 2022',
      title: 'Registre du cancer et biobanque, Medical University Pleven',
      description: [
        'Analyse des données du registre national du cancer et tableaux de bord Shiny pour des parties prenantes cliniques et scientifiques ; appui à l’intégration des données, à la documentation et aux flux de travail de la biobanque pour cinq types de cancer.'
      ]
    },
    {
      period: 'Depuis 2025',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Application R Shiny prête pour la production ; migration des données CSV vers SQLite, authentification administrateur, gestion des institutions, statistiques de fréquentation, inscriptions payantes et formulaires de demande avec notifications SMTP.',
        'Amélioration de l’UI/UX adaptative, du SEO, des données structurées et de la prise en charge sitemap/robots ; validation des entrées, échappement des sorties, limitation des tentatives de connexion et publication des seuls enregistrements vérifiés. Audit de 400+ institutions à l’aide d’ELLIS, CAIRNE, AI NATION, NET4AI, INSAIT et AI-on-Demand, avec documentation de la provenance, de la vérification, du déploiement et de la sécurité.'
      ]
    },
    {
      period: 'Depuis 2024',
      title: 'Analyse d’actualités financières par LLM, Leap Dynamics (projet interne)',
      description: [
        'Analyses de sentiment récurrentes avec des LLM, des données d’API, des rapports PDF automatisés, une interface Streamlit, une orchestration n8n et des tests de flux de travail assistés par Flowise.'
      ]
    },
    {
      period: '2025',
      title: 'Ateliers pour dirigeants, BVMW',
      description: [
        'Animation d’ateliers pour des participants de niveau dirigeant au sein du réseau BVMW.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Collaborateur scientifique, Humboldt-Universität / Charité, Berlin',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO & cofondateur, Promethano GmbH',
      description: [
        'Logiciels et applications de séries temporelles pour les sciences de la vie.'
      ]
    }
  ]
};
